import { decodeUriComponentSafely } from './endpoint-candidate-normalization';
import { isParameterSegment, splitPath } from './endpoint-identity';

const UUID_SEGMENT =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const MONGO_ID_SEGMENT = /^[0-9a-f]{24}$/i;
const NUMERIC_ID_SEGMENT = /^\d+$/;

const isConcreteResourceIdSegment = (segment: string): boolean =>
  isParameterSegment(segment) ||
  UUID_SEGMENT.test(segment) ||
  MONGO_ID_SEGMENT.test(segment) ||
  NUMERIC_ID_SEGMENT.test(segment);

const pathFromUrl = (url: string): string | null => {
  try {
    return decodeUriComponentSafely(new URL(url).pathname);
  } catch {
    return null;
  }
};

const collectionFamilyKey = (url: string): string | null => {
  const path = pathFromUrl(url);

  if (path === null) {
    return null;
  }

  let origin: string;

  try {
    origin = new URL(url).origin.toLowerCase();
  } catch {
    return null;
  }

  const staticSegments = splitPath(path).filter(
    (segment) => !isConcreteResourceIdSegment(segment),
  );

  if (staticSegments.length === 0) {
    return null;
  }

  return `${origin}/${staticSegments.join('/').toLowerCase()}`;
};

export const sameCollectionFamily = ({
  left,
  right,
}: {
  left: string;
  right: string;
}): boolean => {
  const leftKey = collectionFamilyKey(left);
  const rightKey = collectionFamilyKey(right);

  return leftKey !== null && leftKey === rightKey;
};
